import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"banana"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M18.0001 7.50098C17.3794 13.501 13.1106 16.253 8.23674 15.0718C5.15542 14.1025 4.22777 11.501 4.00005 10.501C3.77233 9.50098 4.23155 9.50602 4.96585 9.85568C5.70014 10.2053 8.11762 11.6743 11.0001 11.501C15.9358 11.2042 17.3226 8.88616 18.0001 7.50098Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 4.1802L18 2.98047V7.50129C17.3793 13.5013 13.1105 16.2533 8.23668 15.0721C6.63432 14.6837 4.57637 14.0341 2.95083 13.1895C2.33917 12.8717 2 13.7136 2 14.5013C2 18.0013 7.42237 22.3043 14.0075 20.6236C20.5926 18.9428 23.7632 11.3288 21 7.50129V4.1802Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M18.0001 7.50098C17.3794 13.501 13.1106 16.253 8.23674 15.0718C5.15542 14.1025 4.22777 11.501 4.00005 10.501C3.77233 9.50098 4.23155 9.50602 4.96585 9.85568C5.70014 10.2053 8.11762 11.6743 11.0001 11.501C15.9358 11.2042 17.3226 8.88616 18.0001 7.50098Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 4.1802L18 2.98047V7.50129C17.3793 13.5013 13.1105 16.2533 8.23668 15.0721C6.63432 14.6837 4.57637 14.0341 2.95083 13.1895C2.33917 12.8717 2 13.7136 2 14.5013C2 18.0013 7.42237 22.3043 14.0075 20.6236C20.5926 18.9428 23.7632 11.3288 21 7.50129V4.1802Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Banana = Vue.extend<IconProps>({
  name: 'BananaIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'banana',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Banana;
